<div class="md:sticky z-1 md:top-0 md:px-6 md:mb-[1.5rem] md:pt-6">
  <header
    class="relative z-20 flex max-w-[78rem] mx-auto my-0 justify-between bg-white px-[1.5rem] py-3  md:rounded-lg {{ searchBarSectionOpened() ? '!rounded-b-none' : 'md:shadow-lg' }}"
  >
    <!-- Logos -->
    <a
      [routerLink]="isErrorPage() ? null : '/'"
      class="my-auto"
      [class.pointer-events-none]="isErrorPage()"
      ><div class="flex items-center gap-[0.625rem]">
        <img
          class="w-fit md:h-[1.875rem] h-[1.25rem]"
          src="assets/images/vinci-construction.svg"
          alt="Logo Vinci"
        />
        <img
          class="mt-[0.375rem] h-[1.25rem]"
          src="assets/images/my-path.svg"
          alt="Logo MyPath"
        /></div
    ></a>

    <!-- Navigation desktop -->
    <nav class="hidden md:flex gap-[2rem] items-center">
      <a
        [routerLink]="'/development'"
        routerLinkActive="active-link"
        class="nav-link font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-600"
        [class.pointer-events-none]="isErrorPage()"
        [class.opacity-50]="isErrorPage()"
      >
        {{ 'header.navigation.development' | transloco }}
      </a>
      <a
        [routerLink]="'/mobility'"
        routerLinkActive="active-link"
        class="nav-link font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-600"
        [class.pointer-events-none]="isErrorPage()"
        [class.opacity-50]="isErrorPage()"
      >
        {{ 'header.navigation.mobility' | transloco }}
      </a>
      <a
        [routerLink]="'/journey'"
        routerLinkActive="active-link"
        class="nav-link font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-600"
        [class.pointer-events-none]="isErrorPage()"
        [class.opacity-50]="isErrorPage()"
      >
        {{ 'header.navigation.personalizedJourney' | transloco }}
      </a>
    </nav>

    <div class="flex gap-2 md:gap-6 items-center">
      <button
        (click)="toggleSearchBarSection()"
        [disabled]="isErrorPage()"
        [class]="'relative rounded-lg hover:cursor-pointer px-3 pt-2 before:content-[\'\'] before:absolute before:-inset-y-2 before:inset-x-0 before:rounded-lg before:bg-vinciGrey-50 before:border before:border-vinciGrey-300 before:transition-opacity before:duration-500 before:z-0 before:pointer-events-none focus-visible:before:opacity-100 hover:before:opacity-100 ' + (searchBarSectionOpened() ? 'before:opacity-100' : 'before:opacity-0') + (isErrorPage() ? ' opacity-50 !cursor-not-allowed' : '')"
      >
        <span class="relative z-10">
          <icon [name]="'glass'" [size]="'1.375rem'"></icon>
        </span>
      </button>
      <button
        (click)="router.navigate(['/user-profile'])"
        [disabled]="isErrorPage()"
        class="relative flex gap-2 items-center font-bold mobile-hidden rounded-lg hover:cursor-pointer px-3 before:content-[''] before:absolute before:-inset-y-2 before:inset-x-0 before:rounded-lg before:bg-vinciGrey-50 before:border before:border-vinciGrey-300 before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-500 before:z-0 before:pointer-events-none focus-visible:before:opacity-100"
        [class.opacity-50]="isErrorPage()"
        [class.!cursor-not-allowed]="isErrorPage()"
      >
        <span class="relative z-10 flex gap-2 items-center text-[0.875rem]">
          <icon [name]="'user'" [size]="'1.3125rem'"></icon>
          {{ 'header.navigation.profile' | transloco }}
        </span>
      </button>
      <div
        class="relative"
        appClickOutside
        (appClickOutside)="languageMenuOpened.set(false)"
      >
        <app-button
          [text]="currentLang() | uppercase"
          [icon]="languageMenuOpened() ? 'nav-arrow-up' : 'nav-arrow-down'"
          [extraClass]="languageMenuOpened() ? 'ring-2 ring-vinciBlue-400 ring-offset-vinciGrey-50 ring-offset-4' : ''"
          (buttonClick)="toggleLanguageMenu()"
          [extraClassForText]="'!text-[0.875rem]'"
          [disabled]="!canChangeLanguage()"
        ></app-button>
        @if (languageMenuOpened()) {
        <div
          class="absolute top-full left-1/2 -translate-x-1/2 mt-6 max-h-[9.375rem] bg-white rounded-lg py-2 flex flex-col gap-2 divide-y-1 md:shadow-lg overflow-y-auto z-49"
        >
          @for (lang of availableLangs; track $index) {
          <button
            class="transition-colors duration-300 hover:text-vinciBlue-400 hover:cursor-pointer px-2 py-1 !text-[0.875rem]"
            (click)="changeLang(lang.id)"
          >
            {{ lang.label }}
          </button>
          }
        </div>
        }
      </div>

      <button
        class="desktop-hidden flex items-center justify-center"
        [disabled]="isErrorPage()"
        [class.opacity-50]="isErrorPage()"
        [class.!cursor-not-allowed]="isErrorPage()"
        (click)="toggleBurgerMenu()"
      >
        @if(burgerMenuOpened()){
        <icon [name]="'close'" [color]="'text-vinciBlue-600'"></icon>
        } @else {
        <icon [name]="'burger-menu'" [color]="'text-vinciBlue-600'"></icon>
        }
      </button>
    </div>
  </header>

  <!-- Search bar - priorité la plus haute -->
  @if(searchBarSectionOpened()){
  <div
    class="relative px-6 z-[100]"
    (appClickOutside)="this.searchBarSectionOpened.set(false)"
    appClickOutside
  >
    <div class="absolute z-[100] max-w-[78rem] w-full mx-auto left-0 right-0">
      <div
        class="max-w-[78rem] mx-auto bg-white px-[1.5rem] py-4 rounded-b-lg shadow-lg border-t-1 border-vinciGrey-200"
      >
        <search-bar
          (closeSearchbar)="searchBarSectionOpened.set(false)"
        ></search-bar>
      </div>
    </div>
  </div>

  }

  <!-- Navigation mobile -->
  @if(!searchBarSectionOpened()){
  <nav
    [class]="'desktop-hidden absolute z-20 w-full flex flex-col divide-y-1 divide-vinciBlue-300 bg-white transition-all duration-300 ease-in-out ' + (burgerMenuOpened() ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none')"
  >
    <a
      [routerLink]="'/development'"
      (click)="toggleBurgerMenu()"
      class="py-3 px-6 font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-400"
    >
      {{ 'header.navigation.development' | transloco }}
    </a>
    <a
      [routerLink]="'/mobility'"
      (click)="toggleBurgerMenu()"
      class="py-3 px-6 font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-400"
    >
      {{ 'header.navigation.mobility' | transloco }}
    </a>
    <a
      routerLink="/journey"
      (click)="toggleBurgerMenu()"
      class="py-3 px-6 font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-400"
    >
      {{ 'header.navigation.personalizedJourney' | transloco }}
    </a>
    <a
      routerLink="/user-profile"
      (click)="toggleBurgerMenu()"
      class="py-3 px-6 font-bold text-[0.875rem]/[1.375rem] transition-colors duration-300 hover:text-vinciBlue-400"
    >
      {{ 'header.navigation.profile' | transloco }}
    </a>
  </nav>
  }

  <!-- Overlay grisé -->
  @if(burgerMenuOpened() && !searchBarSectionOpened()){
  <div
    class="fixed inset-0 bg-black/50 z-[15] transition-opacity duration-300 opacity-100 pointer-events-auto"
    (click)="toggleBurgerMenu()"
  ></div>
  }
</div>
